import {Dropdown} from '@/components/atoms'
import {FC} from 'react'
import {RewardItemProps} from './RewardItem'
import {useRewardGiftItem} from './useRewardGiftItem'

export const RewardGiftItem: FC<RewardItemProps> = ({promotionCondition, rewardIndex = 0}) => {
  const {
    quantityOptions,
    giftItemOptions,
    quantityValue,
    giftItemValue,
    isError,
    handleQuantityChange,
    handleGiftItemChange,
  } = useRewardGiftItem({promotionCondition, rewardIndex})

  return (
    <>
      <Dropdown
        isJsonWrap={false}
        childList={quantityOptions}
        placeholder="Any"
        updateValue={handleQuantityChange}
        value={quantityValue}
        isClearable={false}
        // @ts-expect-error type
        style={{maxWidth: '120px'}}
        autocomplete="off"
        isError={isError}
        errorMessage="Value Invalid"
      />
      <Dropdown
        isJsonWrap={false}
        childList={giftItemOptions}
        placeholder="Any"
        updateValue={handleGiftItemChange}
        isClearable={false}
        value={giftItemValue}
        autocomplete="off"
      />
    </>
  )
}
